import commandAccessService from 'command/commandAccessService';
import { ReactElement, useState } from "react"
import LinkList, { LinkListRoute } from 'LinkList';
import { useParams } from "react-router";
import { NxSelect, NxLoader, NxPopup, NxRow, NxButton, NxButtonVariant, NxRowPosition } from "@nextbank/ui-components";
import NxHeader from "form/NxHeader";
import useAxios from "axios-hooks";
import { CustomerProfile } from '../../../app/components/customer/profile/customer-profile.types';
import { HttpError } from "tools/HttpTypes";
import { useCommand } from 'command/CommandService';
import styles from './Cocree.scss';

interface CocreeIndicator {
    id: number;
    cocreeIndicator: boolean;
}

const Cocree = (): ReactElement => {
    const { customerId } = useParams<{ customerId: string }>();
    const [{ data: customerData, loading: customerLoading }, fetchCustomerData] = useAxios<CustomerProfile, HttpError>(
        `/customers/${customerId}`
    );
    const execute = useCommand();
    const [dropdownValue, setDropdownValue] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [confirmDialog, showConfirmDialog] = useState<boolean>(false);

    const requestChange = async (): Promise<void> => {
        try {
            setLoading(true);
            await execute<CocreeIndicator, void>({
                name: 'UpdateCustomerCocreeIndicator',
                input: {
                    id: Number(customerId),
                    cocreeIndicator: dropdownValue
                }
            });
            await fetchCustomerData();
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false)
        }
    }

    const links: LinkListRoute[] = [
        {
            name: 'Subject',
            path: `/customer/${customerId}/cocree/subject`
        },
        {
            name: 'Exposure',
            path: `/customer/${customerId}/cocree/exposure`
        },
        {
            name: 'Negative Information',
            path: `/customer/${customerId}/cocree/negative-information`
        },
    ];

    return (
        <>
            {loading || customerLoading ? <NxLoader/> : (
                <div>
                    {<>
                        <NxHeader>COCREE</NxHeader>
                        
                        <div style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "20px"
                        }}>
                            <span style={{
                                marginTop: "10px"
                            }}>Add information for COCREE report?</span>
                            <div style={{
                                marginLeft: "20px",
                                maxWidth: "50rem",
                                minWidth: "auto",
                                width: "100%"
                            }}>
                              <NxSelect disabled={!commandAccessService.canExecute("UpdateCustomerCocreeIndicator")}
                                        value={!!customerData?.cocreeIndicator}
                                        onChange={(changeValue): void => {
                                          setDropdownValue(changeValue!)
                                          showConfirmDialog(true)
                                        }}
                                        options={[{ label: "Yes", value: true }, { label: "No", value: false }]}
                                        label=""
                                        className={styles.cocreeSelect}
                                        />
                            </div>
                        </div>
                    </>}
                    {customerData?.cocreeIndicator && !customerLoading ? <>
                        <LinkList links={links} header="" />
                    </> : null}

                    <NxPopup header="Confirm" open={confirmDialog} description={dropdownValue ? "Enable reporting of customer in COCREE?" : "Disable reporting of customer in COCREE?"}>
                        <NxRow position={NxRowPosition.END}>
                            <NxButton variant={NxButtonVariant.CLOSE} onClick={(): void => showConfirmDialog(false)}>
                                No
                            </NxButton>
                            <NxButton
                                variant={NxButtonVariant.CONTAINED}
                                onClick={(): void => {
                                    requestChange()
                                    showConfirmDialog(false)
                                }}
                            >
                                Yes
                            </NxButton>
                        </NxRow>
                    </NxPopup>
                </div>
            )}
        </>

    )
}

export default Cocree;